export default {
  getTags: state => state.tags,
  getRamais: state => state.ramais,
  getConferencias: state => state.conferencias,
  getCentroDeCustos: state => state.centroDeCustos,
  getDadosRelatorio: state => state.dadosRelatorio,
  getSpecificConferencia: state => id => state.conferencias.find(conferencia => conferencia._id === id),
}
